import { CheckInput, Input } from "../../../../../../common/Input";
import { Select } from "../../../../../../common/Select";
import { formatDateLong } from "../../../../../../utils/textUtils";
import SectionBadge from "../../ui/SectionBadge";

const OtherDetailsTab = ({ form, set, editable }) => {
  const daysOfWeek = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"];

  const handleRestDayToggle = (day, isChecked) => {
    let selectedDays = form.oldRestDay ? form.oldRestDay.split(',').filter(x => x.trim() !== "") : [];

    if (isChecked) {
      if (!selectedDays.includes(day)) selectedDays.push(day);
    } else {
      selectedDays = selectedDays.filter(d => d !== day);
    }

    // Sort them so they always appear in Monday-Sunday order regardless of click order
    const sortedDays = daysOfWeek.filter(d => selectedDays.includes(d));
    set('oldRestDay', sortedDays.join(','));
  };

  const isDaySelected = (day) => {
    return form.oldRestDay?.split(',').includes(day);
  };

  return (
    <div className="space-y-6">
      <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
        <SectionBadge label="Other Details" editable={editable} />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4">
          <Input label="Approved At:" value={form.approvedAt ? formatDateLong(form.approvedAt) : "--"} isDisabled={true} placeholder="-- No Data --" />
          <Input label="Departure Date:" value={form.departedAt ? formatDateLong(form.departedAt) : "--"} isDisabled={true} placeholder="-- No Data --" />
          <Input label="Onboard Date:" value={form.arrivedAt ? formatDateLong(form.arrivedAt) : "--"} isDisabled={true} placeholder="-- No Data --" />
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
        <SectionBadge label="Old Employee Tagging Details" editable={editable} />
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-10 gap-y-4">

          <Input label="Via Captain:"
            value={form.oldAssignedToName}
            isDisabled={true}
            placeholder="-- No Data --"
          />

          <Input label="Employee Type:"
            value={form.oldEmployeeTypeDescription}
            isDisabled={true}
            placeholder="-- No Data --"
          />
          <Input label="Destination Vessel:"
            value={form.oldDestinationVesselName}
            isDisabled={true}
            placeholder="-- No Data --"
          />
          <Input label="Classification:"
            value={form.oldClassificationName}
            isDisabled={true}
            placeholder="-- No Data --"
          />
          <Input label="Department:"
            value={form.oldDepartmentName}
            isDisabled={true}
            placeholder="-- No Data --"
          />
          <Input label="Title:"
            value={form.oldPositionName}
            isDisabled={true}
            placeholder="-- No Data --"
          />
          <Input label="Employment:"
            value={form.oldEmploymentName}
            isDisabled={true}
            placeholder="-- No Data --"
          />
        </div>
      </div>

      <div className="bg-gray-50 p-6 rounded-xl border border-gray-200">
        <SectionBadge label="Old Rest Day(s)" editable={editable} />
        <div className="space-y-4">
          {/* MODIFIED: Rest Day Selection from Dropdown to Multi-Checkbox */}
          <div>
            <div className={`grid grid-cols-1 sm:grid-cols-3 gap-1 p-3 border rounded-lg bg-white border-gray-300`}>
              {daysOfWeek.map(day => (
                <CheckInput
                  key={day}
                  name={day}
                  value={isDaySelected(day)}
                  onChange={(checked) => handleRestDayToggle(day, checked)}
                  isEditMode={editable}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default OtherDetailsTab;